export enum Action {
  Edit,
  Delete,
  None,
}
